import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import Utils from "../../../../../../utils/Utils";
import $ from 'jquery'
import OggettiUtili from "../../../../../../utils/OggettiUtili.json"

class DatiLaboratorio extends Component {

    state = {
        datiLaboratorio: {
            dataPrelievo: "",
            AH1N1: "",
            AH3N2: "",
            aNonTipizzabile: "",
            altroSottotipoA: "",
            B: "",
            dataConfermaLaboratorio: "",
            invioCampione: "",
            dataInvioCampione: "",
            complicanzeDescrizione: "",
            dataComplicanza: "",
            eseguitaRadiografia: "",
            polmonite: "",
            polmoniteBatterica: "",
            polmoniteInfluenzale: "",
            polmoniteMista: "",
            ards: "",
            sari: "",
            altroLaboratorioDescrizione: "",
            altroLaboratorio: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.controllaDati = this.controllaDati.bind(this)
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
        this.disabledDate = this.disabledDate.bind(this);
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiLaboratorio) {
            let datiLaboratorio = this.state.datiLaboratorio
            let propLaboratorio = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.datiLaboratorio))
            datiLaboratorio.dataPrelievo = propLaboratorio.dataPrelievo ? propLaboratorio.dataPrelievo : ""
            datiLaboratorio.AH1N1 = propLaboratorio.AH1N1 ? propLaboratorio.AH1N1 : ""
            datiLaboratorio.AH3N2 = propLaboratorio.AH3N2 ? propLaboratorio.AH3N2 : ""
            datiLaboratorio.aNonTipizzabile = propLaboratorio.aNonTipizzabile ? propLaboratorio.aNonTipizzabile : ""
            datiLaboratorio.altroSottotipoA = propLaboratorio.altroSottotipoA ? propLaboratorio.altroSottotipoA : ""
            datiLaboratorio.B = propLaboratorio.B ? propLaboratorio.B : ""
            datiLaboratorio.dataConfermaLaboratorio = propLaboratorio.dataConfermaLaboratorio ? propLaboratorio.dataConfermaLaboratorio : ""
            datiLaboratorio.invioCampione = propLaboratorio.invioCampione ? propLaboratorio.invioCampione : ""
            datiLaboratorio.dataInvioCampione = propLaboratorio.dataInvioCampione ? propLaboratorio.dataInvioCampione : ""
            datiLaboratorio.complicanzeDescrizione = propLaboratorio.complicanzeDescrizione ? propLaboratorio.complicanzeDescrizione : ""
            datiLaboratorio.dataComplicanza = propLaboratorio.dataComplicanza ? propLaboratorio.dataComplicanza : ""
            datiLaboratorio.eseguitaRadiografia = propLaboratorio.eseguitaRadiografia ? propLaboratorio.eseguitaRadiografia : ""
            datiLaboratorio.polmonite = propLaboratorio.polmonite ? propLaboratorio.polmonite : ""
            datiLaboratorio.polmoniteBatterica = propLaboratorio.polmoniteBatterica ? propLaboratorio.polmoniteBatterica : ""
            datiLaboratorio.polmoniteInfluenzale = propLaboratorio.polmoniteInfluenzale ? propLaboratorio.polmoniteInfluenzale : ""
            datiLaboratorio.polmoniteMista = propLaboratorio.polmoniteMista ? propLaboratorio.polmoniteMista : ""
            datiLaboratorio.ards = propLaboratorio.ards ? propLaboratorio.ards : ""
            datiLaboratorio.sari = propLaboratorio.sari ? propLaboratorio.sari : ""
            datiLaboratorio.altroLaboratorioDescrizione = propLaboratorio.altroLaboratorioDescrizione ? propLaboratorio.altroLaboratorioDescrizione : ""
            datiLaboratorio.altroLaboratorio = propLaboratorio.altroLaboratorio ? propLaboratorio.altroLaboratorio : ""
            this.setState({datiLaboratorio: datiLaboratorio})
        }
        this.props.setDatiLaboratorio(this.state.datiLaboratorio)
        this.controllaDati();
        this.disabledDate();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati();
        if (prevState !== this.state) {
            let res = this.createJsonForBackend();
            this.props.setDatiLaboratorio(this.state.datiLaboratorio, this.validate(), res)
        }
        this.disabledDate();
    }

    validate() {

        if (this.state.datiLaboratorio.dataComplicanza) {
            let validatedataComplicanza = Utils.checkDateInterval(this.state.datiLaboratorio.dataComplicanza, "31/12/1899");
            let validatedataComplicanzaOdierna = Utils.checkDateInterval(this.state.datiLaboratorio.dataComplicanza, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataComplicanza) {
                return "Messages.DataComplicanza"
            } else if (!validatedataComplicanzaOdierna) {
                return "Messages.DataComplicanzaOdierna"
            }
        }
        if (this.state.datiLaboratorio.dataConfermaLaboratorio) {
            let validatedataConfermaLaboratorio = Utils.checkDateInterval(this.state.datiLaboratorio.dataConfermaLaboratorio, "31/12/1899");
            let validatedataConfermaLaboratorioOdierna = Utils.checkDateInterval(this.state.datiLaboratorio.dataConfermaLaboratorio, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataConfermaLaboratorio) {
                return "Messages.DataConfermaLaboratorio"
            } else if (!validatedataConfermaLaboratorioOdierna) {
                return "Messages.DataConfermaLaboratorioOdierna"
            }
        }
        if (this.state.datiLaboratorio.dataInvioCampione) {
            let validatedataInvioCampione = Utils.checkDateInterval(this.state.datiLaboratorio.dataInvioCampione, "31/12/1899");
            let validatedataInvioCampioneOdierna = Utils.checkDateInterval(this.state.datiLaboratorio.dataInvioCampione, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataInvioCampione) {
                return "Messages.DataInvioCampione"
            } else if (!validatedataInvioCampioneOdierna) {
                return "Messages.DataInvioCampioneOdierna"
            }
        }
        if (this.state.datiLaboratorio.dataPrelievo) {
            let validatedataPrelievo = Utils.checkDateInterval(this.state.datiLaboratorio.dataPrelievo, "31/12/1899");
            let validatedataPrelievoOdierna = Utils.checkDateInterval(this.state.datiLaboratorio.dataPrelievo, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataPrelievo) {
                return "Messages.DataPrelievo"
            } else if (!validatedataPrelievoOdierna) {
                return "Messages.DataPrelievoOdierna"
            }
        }

        return ""

    }

    disabledDate() {

        if (this.state.datiLaboratorio.invioCampione === "01") {
            $(document).ready(function () {
                $("#dataInvioCampione").datepicker('enable');
            })
        } else {
            $(document).ready(function () {
                $("#dataInvioCampione").datepicker('disable');
            })
        }
        if (this.state.datiLaboratorio.complicanzeDescrizione !== "") {
            $(document).ready(function () {
                $("#dataComplicanza").datepicker('enable');
            })
        } else {
            $(document).ready(function () {
                $("#dataComplicanza").datepicker('disable');
            })
        }
    }

    createJsonForBackend() {
        let dati = this.state.datiLaboratorio
        let ObjectForBackEnd = {}
        ObjectForBackEnd["dataPrelievo"] = dati.dataPrelievo
        ObjectForBackEnd["AH1N1"] = dati.AH1N1
        ObjectForBackEnd["AH3N2"] = dati.AH3N2
        ObjectForBackEnd["aNonTipizzabile"] = dati.aNonTipizzabile
        ObjectForBackEnd["altroSottotipoA"] = dati.altroSottotipoA
        ObjectForBackEnd["B"] = dati.B
        ObjectForBackEnd["dataConfermaLaboratorio"] = dati.dataConfermaLaboratorio
        ObjectForBackEnd["invioCampione"] = dati.invioCampione
        ObjectForBackEnd["dataInvioCampione"] = dati.dataInvioCampione
        ObjectForBackEnd["complicanzeDescrizione"] = dati.complicanzeDescrizione
        ObjectForBackEnd["dataComplicanza"] = dati.dataComplicanza
        ObjectForBackEnd["eseguitaRadiografia"] = dati.eseguitaRadiografia
        ObjectForBackEnd["polmonite"] = dati.polmonite
        ObjectForBackEnd["polmoniteBatterica"] = dati.polmoniteBatterica
        ObjectForBackEnd["polmoniteInfluenzale"] = dati.polmoniteInfluenzale
        ObjectForBackEnd["polmoniteMista"] = dati.polmoniteMista
        ObjectForBackEnd["ards"] = dati.ards
        ObjectForBackEnd["sari"] = dati.sari
        ObjectForBackEnd["altroLaboratorioDescrizione"] = dati.altroLaboratorioDescrizione
        ObjectForBackEnd["altroLaboratorio"] = dati.altroLaboratorio

        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        return res;


    }

    controllaDati() {

        let dati = this.state.datiLaboratorio
        dati.corretto = []

        if (dati.dataPrelievo && Utils.isDateInValid(Utils.transformDateForBackend(dati.dataPrelievo), "-")) dati.corretto[0] = "Campo \"Data del Prelievo\" errato";
        if (dati.AH1N1 !== "01" && dati.AH3N2 !== "01" && dati.aNonTipizzabile !== "01" && !dati.altroSottotipoA) dati.corretto[1] = "Campo \"A/Altro sottotipo:\" errato";
        if (dati.invioCampione === "01" && (!dati.dataInvioCampione || (dati.dataInvioCampione && Utils.isDateInValid(Utils.transformDateForBackend(dati.dataInvioCampione), "-")))) dati.corretto[2] = "Campo \"Data di invio\" mancante o errato";
        if (dati.complicanzeDescrizione && (!dati.dataComplicanza || (dati.dataComplicanza && Utils.isDateInValid(Utils.transformDateForBackend(dati.dataComplicanza), "-")))) dati.corretto[3] = "Campo \"Data complicanza\" mancante o errato";
        if (dati.polmonite === "01") {
            if (!dati.polmoniteInfluenzale) dati.corretto[4] = "Campo \"Polmonite influenzale primaria\" errato";
            if (!dati.polmoniteBatterica) dati.corretto[5] = "Campo \"Polmonite batterica secondaria\" errato";
            if (!dati.polmoniteMista) dati.corretto[6] = "Campo \"Polmonite mista\" errato";
        }
        if (!dati.B) dati.corretto[7] = "Campo \"B\" errato";
        if (!dati.sari) dati.corretto[8] = "Campo \"Grave insufficienza respiratioria acuta (SARI) (vedi definizione allegata)\" errato";
        if (!dati.ards) dati.corretto[9] = "Campo \"Acute Respiratory Distress Syndrome (ARDS) (vedi definizione allegata)\" errato";
        if (!this.state.datiLaboratorio.altroLaboratorioDescrizione && this.state.datiLaboratorio.altroLaboratorio === "01") dati.corretto[10] = "Campo \"Altro:\" errato";
    }

    riceviValoreRadioButton(event, field) {
        let datiLaboratorio = this.state.datiLaboratorio
        datiLaboratorio[field] = event

        if (field === "polmonite") {
            datiLaboratorio[field] = event

            datiLaboratorio.polmoniteBatterica = ""
            datiLaboratorio.polmoniteInfluenzale = ""
            datiLaboratorio.polmoniteMista = ""
        }
        if (datiLaboratorio.invioCampione !== "01") {
            datiLaboratorio.dataInvioCampione = ""
            datiLaboratorio.complicanzeDescrizione = ""
            datiLaboratorio.dataComplicanza = ""
        }

        if (datiLaboratorio.altroLaboratorio !== "01") {
            datiLaboratorio.altroLaboratorioDescrizione = ""
        }

        this.setState({datiLaboratorio: datiLaboratorio})
    }

    riceviValoreInput(field, event) {

        let datiLaboratorio = this.state.datiLaboratorio
        if (field.currentTarget) {
            datiLaboratorio[field.currentTarget.id] = field.currentTarget.value
        } else {
            datiLaboratorio[field] = event.target.value
        }

        if (!datiLaboratorio.complicanzeDescrizione) {
            datiLaboratorio.dataComplicanza = ""
        }
        this.setState({datiLaboratorio: datiLaboratorio})
    }

    render() {

        const {t} = this.props

        return (
            <div style={{marginTop: "20px"}}>
                <div>
                    <h6>{t("SchedaInfluenzaGrave.datiLaboratorio")}</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>

                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-3">
                            <p style={{marginTop: "10px"}}><b>{t("SchedaInfluenzaGrave.dataPrelievo")}</b></p>

                        </div>
                        <div className="col-lg-3">
                            <Calendar id={"dataPrelievo"}
                                      field={"dataPrelievo"}
                                      value={this.state.datiLaboratorio.dataPrelievo}
                                      onChange={this.riceviValoreInput}
                                      errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                          "Data")}
                                      error={(this.state.datiLaboratorio.dataPrelievo === "" ||
                                          this.state.datiLaboratorio.dataPrelievo == null) ? false :
                                          Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiLaboratorio.dataPrelievo), "-")}>
                            </Calendar>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-3">
                            <p style={{marginTop: "10px"}}><b>{t("SchedaInfluenzaGrave.confermatoPer")}: <span
                                className={styles.mandatoryColor}>*</span></b></p>

                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.AH1N1")}</b></p>

                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"AH1N1Si"}
                                             name={"AH1N1"} label={t("SchedaInfluenzaGrave.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "AH1N1")}
                                             checked={this.state.datiLaboratorio.AH1N1 === "01"}>
                                </RadioButton>
                                <RadioButton id={"AH1N1No"}
                                             name={"AH1N1"} label={t("SchedaInfluenzaGrave.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "AH1N1")}
                                             checked={this.state.datiLaboratorio.AH1N1 === "02"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.AH3N2")}</b></p>

                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"AH3N2Si"}
                                             name={"AH3N2"} label={t("SchedaInfluenzaGrave.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "AH3N2")}
                                             checked={this.state.datiLaboratorio.AH3N2 === "01"}>
                                </RadioButton>
                                <RadioButton id={"AH3N2No"}
                                             name={"AH3N2"} label={t("SchedaInfluenzaGrave.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "AH3N2")}
                                             checked={this.state.datiLaboratorio.AH3N2 === "02"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.aNonTipizzabile")}</b></p>

                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"aNonTipizzabileSi"}
                                             name={"aNonTipizzabile"} label={t("SchedaInfluenzaGrave.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "aNonTipizzabile")}
                                             checked={this.state.datiLaboratorio.aNonTipizzabile === "01"}>
                                </RadioButton>
                                <RadioButton id={"aNonTipizzabileNo"}
                                             name={"aNonTipizzabile"} label={t("SchedaInfluenzaGrave.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "aNonTipizzabile")}
                                             checked={this.state.datiLaboratorio.aNonTipizzabile === "02"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.aAltro")}:</b>
                                {this.state.datiLaboratorio.AH1N1 !== "01" && this.state.datiLaboratorio.AH3N2 !== "01" &&
                                this.state.datiLaboratorio.aNonTipizzabile !== "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>

                        </div>
                        <div className="col-lg-3">
                            <Input id={"altroSottotipoA"}
                                   field={"altroSottotipoA"}
                                   value={this.state.datiLaboratorio.altroSottotipoA}
                                   placeholder={"Altro"}
                                   onChange={this.riceviValoreInput}>
                            </Input>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}><b>B<span
                                className={styles.mandatoryColor}>*</span></b></p>

                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"Bi"}
                                             name={"B"} label={t("SchedaInfluenzaGrave.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "B")}
                                             checked={this.state.datiLaboratorio.B === "01"}>
                                </RadioButton>
                                <RadioButton id={"BNo"}
                                             name={"B"} label={t("SchedaInfluenzaGrave.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "B")}
                                             checked={this.state.datiLaboratorio.B === "02"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.dataConfermaLaboratorio")}<span
                                    className={styles.mandatoryColor}>*</span></b></p>

                        </div>
                        <div className="col-lg-3">
                            <Calendar id="dataConfermaLaboratorio"
                                      field={"dataConfermaLaboratorio"}
                                      value={this.state.datiLaboratorio.dataConfermaLaboratorio}
                                      onChange={this.riceviValoreInput}
                                      errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                          "Data")}
                                      error={(this.state.datiLaboratorio.dataConfermaLaboratorio === "" ||
                                          this.state.datiLaboratorio.dataConfermaLaboratorio == null) ? false :
                                          Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiLaboratorio.dataConfermaLaboratorio), "-")}
                            />
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.invioCampione")} </b></p>

                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"invioCampioneSi"}
                                             name={"invioCampione"} label={t("SchedaInfluenzaGrave.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "invioCampione")}
                                             checked={this.state.datiLaboratorio.invioCampione === "01"}>
                                </RadioButton>
                                <RadioButton id={"invioCampioneNo"}
                                             name={"invioCampione"} label={t("SchedaInfluenzaGrave.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "invioCampione")}
                                             checked={this.state.datiLaboratorio.invioCampione === "02"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.dataInvio")}{this.state.datiLaboratorio.invioCampione === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""} </b></p>

                        </div>
                        <div className="col-lg-3">
                            <Calendar id="dataInvioCampione"
                                      field={"dataInvioCampione"}
                                      value={this.state.datiLaboratorio.dataInvioCampione}
                                      onChange={this.riceviValoreInput}
                                      disabled={this.state.datiLaboratorio.invioCampione !== "01"}
                                      errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                          "Data")}
                                      error={(this.state.datiLaboratorio.dataInvioCampione === "" ||
                                          this.state.datiLaboratorio.dataInvioCampione == null) ? false :
                                          Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiLaboratorio.dataInvioCampione), "-")}
                            />
                        </div>
                    </div>
                </div>
                <div style={{marginTop: "10px"}}>
                    <h6>{t("SchedaInfluenzaGrave.Complicanze")}</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-3">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.seComplicanze")}</b></p>

                        </div>
                        <div className="col-lg-9">
                            <Input id="complicanzeDescrizione"
                                   field={"complicanzeDescrizione"}
                                   type={"textarea"}
                                   value={this.state.datiLaboratorio.complicanzeDescrizione}
                                   placeholder={"Altro"}
                                   onChange={this.riceviValoreInput}
                            />
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-3">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.dataComplicanza")} {this.state.datiLaboratorio.complicanzeDescrizione !== "" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""} </b></p>

                        </div>
                        <div className="col-lg-3">
                            <Calendar id="dataComplicanza"
                                      field={"dataComplicanza"}
                                      value={this.state.datiLaboratorio.dataComplicanza}
                                      onChange={this.riceviValoreInput}
                                      disabled={!this.state.datiLaboratorio.complicanzeDescrizione}
                                      errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                          "Data")}
                                      error={(this.state.datiLaboratorio.dataComplicanza === "" ||
                                          this.state.datiLaboratorio.dataComplicanza == null) ? false :
                                          Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiLaboratorio.dataComplicanza), "-")}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.eseguitaRadiografia")}</b></p>

                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"eseguitaRadiografiaSi"}
                                             name={"eseguitaRadiografia"} label={t("SchedaInfluenzaGrave.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "eseguitaRadiografia")}
                                             checked={this.state.datiLaboratorio.eseguitaRadiografia === "01"}>
                                </RadioButton>
                                <RadioButton id={"eseguitaRadiografiaNo"}
                                             name={"eseguitaRadiografia"} label={t("SchedaInfluenzaGrave.no")}
                                             onClick={() => this.riceviValoreRadioButton("02", "eseguitaRadiografia")}
                                             checked={this.state.datiLaboratorio.eseguitaRadiografia === "02"}
                                />
                                <RadioButton id={"eseguitaRadiografiaNonSo"}
                                             name={"eseguitaRadiografia"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "eseguitaRadiografia")}
                                             checked={this.state.datiLaboratorio.eseguitaRadiografia === "03"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.polmonite")}</b></p>

                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"polmoniteSi"}
                                             name={"polmonite"} label={t("SchedaInfluenzaGrave.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "polmonite")}
                                             checked={this.state.datiLaboratorio.polmonite === "01"}>
                                </RadioButton>
                                <RadioButton id={"polmoniteNo"}
                                             name={"polmonite"} label={t("SchedaInfluenzaGrave.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "polmonite")}
                                             checked={this.state.datiLaboratorio.polmonite === "02"}
                                />
                                <RadioButton id={"epolmoniteNonSo"}
                                             name={"polmonite"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "polmonite")}
                                             checked={this.state.datiLaboratorio.polmonite === "03"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.polmoniteInfluenzale")}</b>
                                {this.state.datiLaboratorio.polmonite === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>

                        </div>
                        <div className="col-lg-3">
                            <fieldset disabled={this.state.datiLaboratorio.polmonite !== "01"}>

                                <div className="row">
                                    <RadioButton id={"polmoniteInfluenzaleSi"}
                                                 name={"polmoniteInfluenzale"} label={t("SchedaInfluenzaGrave.si")}
                                                 value={"01"}
                                                 onClick={() => this.riceviValoreRadioButton("01", "polmoniteInfluenzale")}
                                                 disabled={this.state.datiLaboratorio.polmonite !== "01"}
                                                 checked={this.state.datiLaboratorio.polmoniteInfluenzale === "01"}>
                                    </RadioButton>
                                    <RadioButton id={"polmoniteInfluenzaleNo"}
                                                 name={"polmoniteInfluenzale"} label={t("SchedaInfluenzaGrave.no")}
                                                 value={"02"}
                                                 disabled={this.state.datiLaboratorio.polmonite !== "01"}
                                                 onClick={() => this.riceviValoreRadioButton("02", "polmoniteInfluenzale")}
                                                 checked={this.state.datiLaboratorio.polmoniteInfluenzale === "02"}
                                    />
                                    <RadioButton id={"polmoniteInfluenzaleNonSo"}
                                                 name={"polmoniteInfluenzale"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                                 value={"03"}
                                                 disabled={this.state.datiLaboratorio.polmonite !== "01"}
                                                 onClick={() => this.riceviValoreRadioButton("03", "polmoniteInfluenzale")}
                                                 checked={this.state.datiLaboratorio.polmoniteInfluenzale === "03"}
                                    />
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.polmoniteBatterica")}</b>
                                {this.state.datiLaboratorio.polmonite === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>

                        </div>
                        <div className="col-lg-3">
                            <fieldset disabled={this.state.datiLaboratorio.polmonite !== "01"}>
                                <div className="row">
                                    <RadioButton id={"polmoniteBattericaSi"}
                                                 name={"polmoniteBatterica"} label={t("SchedaInfluenzaGrave.si")}
                                                 value={"01"} disabled={this.state.datiLaboratorio.polmonite !== "01"}
                                                 onClick={() => this.riceviValoreRadioButton("01", "polmoniteBatterica")}
                                                 checked={this.state.datiLaboratorio.polmoniteBatterica === "01"}>
                                    </RadioButton>
                                    <RadioButton id={"polmoniteBattericaNo"}
                                                 disabled={this.state.datiLaboratorio.polmonite !== "01"}
                                                 name={"polmoniteBatterica"} label={t("SchedaInfluenzaGrave.no")}
                                                 value={"02"}
                                                 onClick={() => this.riceviValoreRadioButton("02", "polmoniteBatterica")}
                                                 checked={this.state.datiLaboratorio.polmoniteBatterica === "02"}
                                    />
                                    <RadioButton id={"polmoniteBattericaNonSo"}
                                                 name={"polmoniteBatterica"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                                 value={"03"}
                                                 disabled={this.state.datiLaboratorio.polmonite !== "01"}
                                                 onClick={() => this.riceviValoreRadioButton("03", "polmoniteBatterica")}
                                                 checked={this.state.datiLaboratorio.polmoniteBatterica === "03"}
                                    />
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.polmoniteMista")} </b>
                                {this.state.datiLaboratorio.polmonite === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>

                        </div>
                        <div className="col-lg-3">
                            <fieldset disabled={this.state.datiLaboratorio.polmonite !== "01"}>

                                <div className="row">
                                    <RadioButton id={"polmoniteMistaSi"}
                                                 name={"polmoniteMista"} label={t("SchedaInfluenzaGrave.si")}
                                                 value={"01"}
                                                 onClick={() => this.riceviValoreRadioButton("01", "polmoniteMista")}
                                                 disabled={this.state.datiLaboratorio.polmonite !== "01"}
                                                 checked={this.state.datiLaboratorio.polmoniteMista === "01"}>
                                    </RadioButton>
                                    <RadioButton id={"polmoniteMistaNo"}
                                                 name={"polmoniteMista"} label={t("SchedaInfluenzaGrave.no")}
                                                 value={"02"}
                                                 disabled={this.state.datiLaboratorio.polmonite !== "01"}
                                                 onClick={() => this.riceviValoreRadioButton("02", "polmoniteMista")}
                                                 checked={this.state.datiLaboratorio.polmoniteMista === "02"}
                                    />
                                    <RadioButton id={"polmoniteMistaNonSo"}
                                                 name={"polmoniteMista"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                                 value={"03"}
                                                 disabled={this.state.datiLaboratorio.polmonite !== "01"}
                                                 onClick={() => this.riceviValoreRadioButton("03", "polmoniteMista")}
                                                 checked={this.state.datiLaboratorio.polmoniteMista === "03"}
                                    />
                                </div>
                            </fieldset>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.sari")}<span className={styles.mandatoryColor}>*</span></b>
                            </p>

                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"sariSi"}
                                             name={"sari"} label={t("SchedaInfluenzaGrave.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "sari")}
                                             checked={this.state.datiLaboratorio.sari === "01"}>
                                </RadioButton>
                                <RadioButton id={"sariNo"}
                                             name={"sari"} label={t("SchedaInfluenzaGrave.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "sari")}
                                             checked={this.state.datiLaboratorio.sari === "02"}
                                />
                                <RadioButton id={"sariNonSo"}
                                             name={"sari"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "sari")}
                                             checked={this.state.datiLaboratorio.sari === "03"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.ards")}<span className={styles.mandatoryColor}>*</span></b>
                            </p>

                        </div>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"ardsSi"}
                                             name={"ards"} label={t("SchedaInfluenzaGrave.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "ards")}
                                             checked={this.state.datiLaboratorio.ards === "01"}>
                                </RadioButton>
                                <RadioButton id={"ardsNo"}
                                             name={"ards"} label={t("SchedaInfluenzaGrave.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "ards")}
                                             checked={this.state.datiLaboratorio.ards === "02"}
                                />
                                <RadioButton id={"ardsNonSo"}
                                             name={"ards"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "ards")}
                                             checked={this.state.datiLaboratorio.ards === "03"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-1">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaInfluenzaGrave.altro")}:</b>
                                {this.state.datiLaboratorio.altroLaboratorio === "01" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>

                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <Input id={"altroLaboratorioDescrizione"}
                                   field={"altroLaboratorioDescrizione"}
                                   value={this.state.datiLaboratorio.altroLaboratorioDescrizione}
                                   disabled={this.state.datiLaboratorio.altroLaboratorio !== "01"}
                                   placeholder={"Altro"}
                                   onChange={this.riceviValoreInput}>
                            </Input>
                        </div>
                        <div className="col-lg-2"/>
                        <div className="col-lg-3">
                            <div className="row">
                                <RadioButton id={"altroLaboratorioSi"}
                                             name={"altroLaboratorio"} label={t("SchedaInfluenzaGrave.si")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "altroLaboratorio")}
                                             checked={this.state.datiLaboratorio.altroLaboratorio === "01"}>
                                </RadioButton>
                                <RadioButton id={"altroLaboratorioNo"}
                                             name={"altroLaboratorio"} label={t("SchedaInfluenzaGrave.no")}
                                             value={"02"}
                                             onClick={() => this.riceviValoreRadioButton("02", "altroLaboratorio")}
                                             checked={this.state.datiLaboratorio.altroLaboratorio === "02"}
                                />
                                <RadioButton id={"altroLaboratorioNonSo"}
                                             name={"altroLaboratorio"} label={t("SchedaInfluenzaGrave.nonNoto")}
                                             value={"03"}
                                             onClick={() => this.riceviValoreRadioButton("03", "altroLaboratorio")}
                                             checked={this.state.datiLaboratorio.altroLaboratorio === "03"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


}


export default withTranslation('common')(DatiLaboratorio)
